import React from 'react';
import { Card, Tabs } from 'antd';
import {
    ShoppingCartOutlined,
    FileTextOutlined,
    InboxOutlined,
    BarChartOutlined,
    SnippetsOutlined
} from '@ant-design/icons';

import KermesCaja from './components/KermesCaja';
import KermesPedidos from './components/KermesPedidos';
import KermesVentas from './components/KermesVentas';
import KermesInventario from './components/KermesInventario';
import KermesCorte from './components/KermesCorte';

const Kermes = ({ currentUser }) => {

    const apiBase = '/api/kermes';

    const userId = currentUser?.id ?? null;

    const items = [
        {
            key: 'caja',
            label: 'Caja',
            icon: <ShoppingCartOutlined />,
            children: (
                <KermesCaja
                    apiBase={apiBase}
                    userId={userId}
                />
            )
        },
        {
            key:'pedidos',
            label: 'Pedidos',
            icon: <SnippetsOutlined />,
            children: (
                <KermesPedidos
                    apiBase={apiBase}
                    userId={userId}
                />
            )
        },
        {
            key: 'ventas',
            label: 'Ventas',
            icon: <FileTextOutlined />,
            children: (
                <KermesVentas
                    apiBase={apiBase}
                    userId={userId}
                />
            )
        },
        {
            key: 'inventario',
            label: 'Inventario',
            icon: <InboxOutlined />,
            children: (
                <KermesInventario
                    apiBase={apiBase}
                />
            )
        },
        {
            key: 'corte',
            label: 'Corte de caja',
            icon: <BarChartOutlined />,
            children: (
                <KermesCorte
                    apiBase={apiBase}
                />
            )
        }
    ];

    return (
        <Card
            title="Kermés 2026 - Dinámica Juvenil"
            bordered={false}
        >
            <Tabs
                defaultActiveKey="caja"
                items={items}
            />
        </Card>
    );
};

export default Kermes;